// ============================================================================
// ACTIVE: 4-service backend (Expense / Project Planning / Master / HRMS)
// ============================================================================
import axios from "./axios";
import store from "../store";

// The backend has been split into 4 separate services. Base URLs come from
// .env (deployed defaults, committed). To point at services running locally,
// copy .env.local.example to .env.local and adjust -- Vue CLI loads it
// automatically and it overrides .env, so no code changes are needed to switch.
var apibaseurlExpense = process.env.VUE_APP_API_EXPENSE; // Expense API
var apibaseurlProjectPlanning = process.env.VUE_APP_API_PROJECT_PLANNING; // Project Planning API
var apibaseurlMaster = process.env.VUE_APP_API_MASTER; // Master API
var apibaseurlHRMS = process.env.VUE_APP_API_HRMS; // HRMS API
var apibaseurlStaffing = process.env.VUE_APP_API_STAFFING; // Staffing API (MRF, recruitment tracker, offer letters, candidate docs, onboarding)
var apibaseurlTraining = process.env.VUE_APP_API_TRAINING; // Training API (competencies, TNA, training plan, sessions, effectiveness)


// Create a separate axios instance for Python backend (index-employee)
const pythonAxios = axios.create({
  baseURL: apibaseurlHRMS,
  timeout: 30000,
});

// Superseded by verifyFaceForPunch (backend now compares against the stored
// face embedding instead of the UI hitting the compare service directly).
// const faceCompareUrl = "http://65.0.55.53:9001/api/v1/faces/compare";
// const faceCompareUrl = "https://faceapi.hr.cerisetechsolutions.com/api/v1/faces/compare";
// const faceCompareAxios = axios.create({
//   timeout: 30000,
// });

let userDetailsPromise = null;

export default {
  loginUser(user) {
    return axios.post(apibaseurlHRMS + "loginUser", JSON.stringify(user));
  },
  getUserDetails() {
    if (!userDetailsPromise) {
      userDetailsPromise = axios
        .post(apibaseurlHRMS + "getUserDetails", {})
        .finally(() => {
          setTimeout(() => {
            userDetailsPromise = null;
          }, 1000);
        });
    }
    return userDetailsPromise;
  },
  addEmployee(data) {
    return axios.post(apibaseurlHRMS + "addEmployee", JSON.stringify(data));
  },
  sendOtp(data) {
    return axios.post(apibaseurlHRMS + "sendOtp", JSON.stringify(data), {});
  },
  verifyOtp(data) {
    return axios.post(apibaseurlHRMS + "verifyOtp", JSON.stringify(data), {});
  },
  addBankdetail(data) {
    return axios.post(apibaseurlHRMS + "addBankDetails", data);
  },
  addAddressDetail(data) {
    return axios.post(apibaseurlHRMS + "addAddressDetails", data);
  },
  addEducationDetails(data) {
    return axios.post(apibaseurlHRMS + "addEducationDetails", data);
  },
  getEmployeeEducationLogById(data) {
    return axios.post(apibaseurlHRMS + "getEmployeeEducationLogById", data);
  },
  addEmployeePayrollStructure(data) {
    return axios.post(apibaseurlHRMS + "addEmployeePayrollStructure", data);
  },
  addAllEmployeeAttendance(data) {
    return axios.post(apibaseurlHRMS + "addAllEmployeeAttendance", data);
  },
  getEmployeePayStructureById(data) {
    return axios.post(apibaseurlHRMS + "getEmployeePayStructureById", data);
  },
  getDefinePayStructureById(data) {
    return axios.post(apibaseurlHRMS + "getDefinePayStructureById", data);
  },
  getEmployeeBankLogById(data) {
    return axios.post(apibaseurlHRMS + "getEmployeeBankLogById", data);
  },
  getEmployeeAddressLogById(data) {
    return axios.post(apibaseurlHRMS + "getEmployeeAddressLogById", data);
  },
  getAllDesignation(data) {
    return axios.post(apibaseurlHRMS + "getAllDesignation", data);
  },
  getAllRole(data) {
    return axios.post(apibaseurlHRMS + "getAllRole", data);
  },
  getAllDepartment(data) {
    return axios.post(apibaseurlHRMS + "getAllDepartment", data);
  },
  getAllLocation(data) {
    return axios.post(apibaseurlHRMS + "getAllLocation", data);
  },
  addEmployeeDesignation(data) {
    return axios.post(apibaseurlHRMS + "addEmployeeDesignation", data);
  },
  addEmployeeDepartment(data) {
    return axios.post(apibaseurlHRMS + "addEmployeeDepartment", data);
  },
  addEmployeeLocation(data) {
    return axios.post(apibaseurlHRMS + "addEmployeeLocation", data);
  },
  getEmployeeDepartmentLogById(data) {
    return axios.post(apibaseurlHRMS + "getEmployeeDepartmentLogById", data);
  },
  getEmployeeLocationLogById(data) {
    return axios.post(apibaseurlHRMS + "getEmployeeLocationLogById", data);
  },
  getEmployeeDesignationLogById(data) {
    return axios.post(apibaseurlHRMS + "getEmployeeDesignationLogById", data);
  },
  addPayrollStructure(data) {
    return axios.post(apibaseurlHRMS + "addPayrollStructure", data);
  },
  addAttendanceDetail(data) {
    return axios.post(apibaseurlHRMS + "addAttendanceDetail", data);
  },
  addNote(data) {
    return axios.post(apibaseurlHRMS + "addNote", data);
  },
  getEmployeeAttendanceById(data) {
    return axios.post(
      apibaseurlHRMS + "getEmployeeAttendanceById",
      JSON.stringify(data)
    );
  },
  getAttendanceDetailById(data) {
    return axios.post(
      apibaseurlMaster + "getAttendanceDetailById",
      JSON.stringify(data)
    );
  },
  // Soft-deletes a pending attendance regularize request ({ request_id }).
  DeleteAttendanceRegularizeRequest(data) {
    return axios.post(
      apibaseurlMaster + "DeleteAttendanceRegularizeRequest",
      JSON.stringify(data)
    );
  },
  getPayStructure(data) {
    return axios.post(apibaseurlHRMS + "getPayStructure", JSON.stringify(data));
  },
  getLeaveDays(data) {
    return axios.post(apibaseurlHRMS + "getLeaveDays", JSON.stringify(data));
  },
  // addAllEmployeeAttendanceDetail(data) {
  //   return axios.post(
  //     apibaseurlHRMS + "addAllEmployeeAttendanceDetail",
  //     JSON.stringify(data),
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: auth,
  //       },
  //     }
  //   );
  // },
  addAllEmployeeAttendanceDetail(data) {
    return axios.post(apibaseurlHRMS + "addAllEmployeeAttendanceDetail", data);
  },
  getAllEmployeeAttendance(data) {
    return axios.post(apibaseurlHRMS + "getAllEmployeeAttendance", data);
  },
  addPayrollStructureWithItems(data) {
    return axios.post(apibaseurlHRMS + "addPayrollStructureWithItems", data);
  },

  updatePayrollStructureWithItems(data) {
    return axios.post(apibaseurlHRMS + "updatePayrollStructureWithItems", data);
  },
  getAllEmployee(data) {
    return axios.post(apibaseurlHRMS + "getEmployees", data);
  },
  getEmployeeDropdown(data) {
    return axios.post(apibaseurlHRMS + "getEmployeeDropdown", data);
  },
  getAllEarningAndDeductionItem(data) {
    return axios.post(apibaseurlHRMS + "getAllEarningAndDeductionItem", data);
  },
  // getAllPayStructure(data) {
  //   return axios.post(apibaseurlHRMS + "getPayStructure", data, {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: auth,
  //     },
  //   });
  // },
  getAllEmployeeWithSalaryDetail(data) {
    return axios.post(apibaseurlHRMS + "getAllEmployeeWithSalaryDetail", data);
  },
  // getAllEmployeeLeaveTypeWithStatus(data) {
  //   return axios.post(apibaseurlHRMS + "getAllEmployeeLeaveTypeWithStatus", data, {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: auth,
  //     },
  //   });
  // },
  getAllEmployeeLeaveTypeWithStatus(payLoad) {
    return axios.post(
      apibaseurlHRMS + "getAllEmployeeLeaveTypeWithStatus",
      JSON.stringify(payLoad)
    );
  },
  getEmployeeDashboard(payLoad) {
    return axios.post(
      apibaseurlHRMS + "getEmployeeDashboard",
      JSON.stringify(payLoad)
    );
  },
  getAdminDashboard(payLoad) {
    return axios.post(
      apibaseurlHRMS + "getAdminDashboard",
      JSON.stringify(payLoad)
    );
  },
  getManagerDashboard(payLoad) {
    return axios.post(
      apibaseurlHRMS + "getManagerDashboard",
      JSON.stringify(payLoad)
    );
  },
  getSuperAdminDashboard(payLoad) {
    return axios.post(
      apibaseurlHRMS + "getSuperAdminDashboard",
      JSON.stringify(payLoad)
    );
  },
  addAttendancePunchDetails(payLoad) {
    return axios.post(
      apibaseurlHRMS + "addAttendancePunchDetails",
      JSON.stringify(payLoad)
    );
  },
  getEmployeeExpenseById(payLoad) {
    return axios.post(
      apibaseurlExpense + "getEmployeeExpenseById",
      JSON.stringify(payLoad)
    );
  },
  getAllEmployeeExpense(payLoad) {
    return axios.post(
      apibaseurlExpense + "getAllEmployeeExpense",
      JSON.stringify(payLoad)
    );
  },
  getAllReimbursementType(payLoad) {
    return axios.post(
      apibaseurlExpense + "getAllReimbursementType",
      JSON.stringify(payLoad)
    );
  },
  addExpenses(data) {
    return axios.post(apibaseurlExpense + "addExpenses", data);
  },
  updateExpenses(data) {
    return axios.post(apibaseurlExpense + "updateExpenses", data);
  },
  deleteExpenses(data) {
    return axios.post(apibaseurlExpense + "deleteExpenses", data);
  },
  updateExpenseRequestStatus(data) {
    return axios.post(apibaseurlExpense + "updateExpenseRequestStatus", data);
  },
  getEmployeeExpenseStatusLogById(payLoad) {
    return axios.post(apibaseurlExpense + "getEmployeeExpenseStatusLogById", payLoad);
  },
  getAllReimbursementStatus(data) {
    return axios.post(apibaseurlExpense + "getAllReimbursementStatus", data);
  },
  ReportedReimbursementStatus(data) {
    return axios.post(apibaseurlExpense + "ReportedReimbursementStatus", data);
  },
  getAllReportedEmployee(payLoad) {
    return axios.post(
      apibaseurlHRMS + "getAllReportedEmployee",
      JSON.stringify(payLoad)
    );
  },
  addEmployeeManagerDetails(data) {
    return axios.post(apibaseurlHRMS + "addEmployeeManagerDetails", data);
  },
  getEmployeeManagerLogById(data) {
    return axios.post(
      apibaseurlHRMS + "getEmployeeManagerLogById",
      JSON.stringify(data)
    );
  },
  getEmployeeManagerStatusLogById(data) {
    return axios.post(
      apibaseurlHRMS + "getEmployeeManagerStatusLogById",
      JSON.stringify(data)
    );
  },
  getAllNotification(data) {
    return axios.post(apibaseurlHRMS + "getAllNotification", JSON.stringify(data));
  },
  checkUnReadNotification(data) {
    return axios.post(apibaseurlHRMS + "checkUnReadNotification", JSON.stringify(data));
  },
  getEmployeeNotificationById(payLoad) {
    return axios.post(
      apibaseurlHRMS + "getEmployeeNotificationById",
      JSON.stringify(payLoad)
    );
  },
  addNotificationMasterDetail(data) {
    return axios.post(apibaseurlHRMS + "addNotificationMasterDetail", data);
  },
  getAllNotificationType(data) {
    return axios.post(apibaseurlHRMS + "getAllNotificationType", data || {});
  },
  deleteNotificationMasterDetail(data) {
    return axios.post(
      apibaseurlHRMS + "deleteNotificationMasterDetail",
      JSON.stringify(data)
    );
  },
  getAllLeaveRequest(data) {
    return axios.post(apibaseurlHRMS + "getAllLeaveRequest", JSON.stringify(data));
  },
  // format: "excel" | "pdf" -- returns { status, data: { url, fileName, totalRecords }, message }
  DownloadEmployeeLeaveRequest(data) {
    return axios.post(apibaseurlHRMS + "DownloadEmployeeLeaveRequest", JSON.stringify(data));
  },
  // getAllLeaveRequest(data) {
  //   return axios.post(apibaseurlHRMS + "getAllLeaveRequest", data);
  // },
  addLeaveRequestDetails(data) {
    return axios.post(apibaseurlHRMS + "addLeaveRequestDetails", data);
  },
  GetHolidayAdminContext(data) {
    return axios.post(apibaseurlMaster + "GetHolidayAdminContext", data);
  },
  GetHolidayList(data) {
    return axios.post(apibaseurlMaster + "GetHolidayList", data);
  },
  GetPendingHolidayList(data) {
    return axios.post(apibaseurlMaster + "GetPendingHolidayList", data);
  },
  AddEditHoliday(data) {
    return axios.post(apibaseurlMaster + "AddEditHoliday", data);
  },
  DeleteHoliday(data) {
    return axios.post(apibaseurlMaster + "DeleteHoliday", data);
  },
  ApproveHoliday(data) {
    return axios.post(apibaseurlMaster + "ApproveHoliday", data);
  },
  RejectHoliday(data) {
    return axios.post(apibaseurlMaster + "RejectHoliday", data);
  },
  getAllHolidayDetails(payLoad) {
    return axios.post(
      apibaseurlHRMS + "getAllHolidayDetails",
      JSON.stringify(payLoad)
    );
  },
  getAllMasterDesignation(payLoad) {
    return axios.post(
      apibaseurlHRMS + "getAllMasterDesignation",
      JSON.stringify(payLoad)
    );
  },
  addMasterDesignation(data) {
    return axios.post(apibaseurlHRMS + "addMasterDesignation", data);
  },
  deleteMasterDesignation(payLoad) {
    return axios.post(
      apibaseurlHRMS + "deleteMasterDesignation",
      JSON.stringify(payLoad)
    );
  },
  getAllMasterEmploymentStatus(payLoad) {
    return axios.post(
      apibaseurlHRMS + "getAllMasterEmploymentStatus",
      JSON.stringify(payLoad)
    );
  },
  addMasterEmploymentStatus(data) {
    return axios.post(apibaseurlHRMS + "addMasterEmploymentStatus", data);
  },
  deleteMasterEmploymentStatus(payLoad) {
    return axios.post(
      apibaseurlHRMS + "deleteMasterEmploymentStatus",
      JSON.stringify(payLoad)
    );
  },
  getAllMasterLeaveTypes(payLoad) {
    return axios.post(
      apibaseurlHRMS + "getAllMasterLeaveTypes",
      JSON.stringify(payLoad)
    );
  },
  addMasterLeaveTypes(data) {
    return axios.post(apibaseurlHRMS + "addMasterLeaveTypes", data);
  },
  deleteMasterLeaveTypes(payLoad) {
    return axios.post(
      apibaseurlHRMS + "deleteMasterLeaveTypes",
      JSON.stringify(payLoad)
    );
  },
  getAllMasterDepartments(payLoad) {
    return axios.post(
      apibaseurlHRMS + "getAllMasterDepartments",
      JSON.stringify(payLoad)
    );
  },

  addMasterDepartments(data) {
    return axios.post(apibaseurlHRMS + "addMasterDepartments", data);
  },
  deleteMasterDepartments(payLoad) {
    return axios.post(
      apibaseurlHRMS + "deleteMasterDepartments",
      JSON.stringify(payLoad)
    );
  },
  getAllMasterEducationType(payLoad) {
    return axios.post(
      apibaseurlHRMS + "getAllMasterEducationType",
      JSON.stringify(payLoad)
    );
  },
  addMasterEducationType(data) {
    return axios.post(apibaseurlHRMS + "addMasterEducationType", data);
  },
  deleteMasterEducationType(payLoad) {
    return axios.post(
      apibaseurlHRMS + "deleteMasterEducationType",
      JSON.stringify(payLoad)
    );
  },
  deleteHolidayDetails(payLoad) {
    return axios.post(
      apibaseurlHRMS + "deleteHolidayDetails",
      JSON.stringify(payLoad)
    );
  },
  GetEmployeePayrollMasterDetails(data) {
    return axios.post(apibaseurlHRMS + "GetEmployeePayrollMasterDetails", data);
  },
  getEmployeeById(payLoad) {
    return axios.post(apibaseurlHRMS + "getEmployeeById", JSON.stringify(payLoad));
  },
  checkDuplicateEmployeeFields(payLoad) {
    return axios.post(
      apibaseurlHRMS + "checkDuplicateEmployeeFields",
      JSON.stringify(payLoad)
    );
  },
  getEmployeeLeaveById(payLoad) {
    return axios.post(
      apibaseurlHRMS + "getEmployeeLeaveById",
      JSON.stringify(payLoad)
    );
  },
  getAttendanceRegularizeById(payLoad) {
    return axios.post(
      apibaseurlHRMS + "getAttendanceRegularizeById",
      JSON.stringify(payLoad)
    );
  },
  updateAttendanceRegulariseRequestDetail(data) {
    return axios.post(
      apibaseurlHRMS + "updateAttendanceRegulariseRequestDetail",
      data
    );
  },
  // Bulk approve/reject from the regularisation approval list's multi-select.
  // Employees selectable in the regularisation Employee filter. Scope is decided
  // server-side from the token: Super Admin gets everyone, others get reportees.
  // Monthly attendance register (read-only report). One call returns the whole
  // month: summary + per-day detail, joined client-side on employeeId.
  getAttendanceRegister(data) {
    return axios.post(apibaseurlHRMS + "GetAttendanceRegister", JSON.stringify(data));
  },
  getAttendanceRegisterEmployees(data) {
    return axios.post(apibaseurlHRMS + "GetAttendanceRegisterEmployees", JSON.stringify(data || {}));
  },
  // Attendance Summary report (Master): present / on leave / exception cards +
  // one paged list per call, picked by `list`.
  GetAttendanceSummaryReport(data) {
    return axios.post(apibaseurlMaster + "GetAttendanceSummaryReport", data);
  },
  // Monthly attendance summary (Expense API, usp_monthly_attendance_summary).
  // Sends { start_date, end_date } as YYYY-MM-DD.
  getMonthlyAttendanceSummary(data) {
    return axios.post(apibaseurlExpense + "getMonthlyAttendanceSummary", JSON.stringify(data));
  },
  // Leave ledger (read-only report). One call returns the whole year: an
  // OPENING BALANCE row per employee/leave type plus every credit and debit
  // with its running balance, and the per-type totals derived from them.
  getLeaveLedger(data) {
    return axios.post(apibaseurlHRMS + "GetLeaveLedger", JSON.stringify(data));
  },
  getLeaveLedgerEmployees(data) {
    return axios.post(apibaseurlHRMS + "GetLeaveLedgerEmployees", JSON.stringify(data || {}));
  },
  getAttendanceRegularizeEmployees(data) {
    return axios.post(
      apibaseurlHRMS + "getAttendanceRegularizeEmployees",
      JSON.stringify(data || {})
    );
  },
  updateBulkAttendanceRegulariseRequestStatus(data) {
    return axios.post(
      apibaseurlHRMS + "updateBulkAttendanceRegulariseRequestStatus",
      JSON.stringify(data)
    );
  },
  updateAttendanceRegulariseRequestStatus(data) {
    return axios.post(
      apibaseurlHRMS + "updateAttendanceRegulariseRequestStatus",
      data
    );
  },
  geAttendanceRegularizeStatusLogById(payLoad) {
    return axios.post(
      apibaseurlHRMS + "geAttendanceRegularizeStatusLogById",
      JSON.stringify(payLoad)
    );
  },
  getAllAttendanceRequestStatus(data) {
    return axios.post(
      apibaseurlHRMS + "getAllAttendanceRequestStatus",
      JSON.stringify(data)
    );
  },
  getAllEmployementStatus(data) {
    return axios.post(apibaseurlHRMS + "getAllEmployementStatus", data);
  },
  getAllExitReason(data) {
    return axios.post(apibaseurlHRMS + "getAllExitReason", data);
  },
  getAllEducationType(data) {
    return axios.post(apibaseurlHRMS + "getAllEducationType", data);
  },
  GetEmployeeAttendanceRegulariseDates(payLoad) {
    return axios.post(
      apibaseurlHRMS + "GetEmployeeAttendanceRegulariseDates",
      JSON.stringify(payLoad)
    );
  },
  addAttendanceRegulariseRequestDetail(data) {
    return axios.post(
      apibaseurlHRMS + "addAttendanceRegulariseRequestDetail",
      data
    );
  },
  getAllAttendanceRegularizeRequest(data) {
    return axios.post(
      apibaseurlHRMS + "getAllAttendanceRegularizeRequest",
      JSON.stringify(data)
    );
  },
  updateLeaveRequestDetails(data) {
    return axios.post(apibaseurlHRMS + "updateLeaveRequestDetails", data);
  },
  updateNotificationDetails(data) {
    return axios.post(apibaseurlHRMS + "updateNotificationDetails", data);
  },
  getAllRequestStatus(data) {
    return axios.post(apibaseurlHRMS + "getAllRequestStatus", data);
  },
  ReportRequestStatus(data) {
    return axios.post(apibaseurlHRMS + "ReportRequestStatus", JSON.stringify(data));
  },
  getAttendaceRegulariseReason(data) {
    return axios.post(apibaseurlHRMS + "getAttendaceRegulariseReason", data);
  },
  // Leave approval list: scoped employee options + bulk decision.
  getLeaveFilterEmployees(data) {
    return axios.post(apibaseurlHRMS + "getLeaveFilterEmployees", JSON.stringify(data || {}));
  },
  updateBulkLeaveRequestStatus(data) {
    return axios.post(apibaseurlHRMS + "updateBulkLeaveRequestStatus", JSON.stringify(data));
  },
  updateLeaveRequestStatus(data) {
    return axios.post(apibaseurlHRMS + "updateLeaveRequestStatus", data);
  },
  deleteLeaveRequest(data) {
    return axios.post(apibaseurlHRMS + "deleteLeaveRequest", JSON.stringify(data));
  },
  // Work From Home (served by the Expense service - the Hrms stack is full). The
  // requester is always the logged-in
  // employee (taken from the token server side), never sent in the body.
  addWfhRequest(data) {
    return axios.post(apibaseurlExpense + "addWfhRequest", JSON.stringify(data));
  },
  // view: "self" (my requests, default) | "approval" (my team's requests)
  getAllWfhRequest(data) {
    return axios.post(apibaseurlExpense + "getAllWfhRequest", JSON.stringify(data || {}));
  },
  getWfhRequestById(data) {
    return axios.post(apibaseurlExpense + "getWfhRequestById", JSON.stringify(data));
  },
  updateWfhRequest(data) {
    return axios.post(apibaseurlExpense + "updateWfhRequest", JSON.stringify(data));
  },
  deleteWfhRequest(data) {
    return axios.post(apibaseurlExpense + "deleteWfhRequest", JSON.stringify(data));
  },
  getWfhStatusLogById(data) {
    return axios.post(apibaseurlExpense + "getWfhStatusLogById", JSON.stringify(data));
  },
  getWfhFilterEmployees() {
    return axios.post(apibaseurlExpense + "getWfhFilterEmployees", JSON.stringify({}));
  },
  updateWfhRequestStatus(data) {
    return axios.post(apibaseurlExpense + "updateWfhRequestStatus", JSON.stringify(data));
  },
  updateBulkWfhRequestStatus(data) {
    return axios.post(apibaseurlExpense + "updateBulkWfhRequestStatus", JSON.stringify(data));
  },
  cancelRemainingLeave(data) {
    return axios.post(apibaseurlHRMS + "cancelRemainingLeave", JSON.stringify(data));
  },
  upload_to_AWS(data) {
    return axios.post(apibaseurlHRMS + "getSignedURL", JSON.stringify(data));
  },
  //payroll
  GetFinalizePaysheetList(payLoad) {
    return axios.post(
      apibaseurlHRMS + "GetFinalizePaysheetList",
      JSON.stringify(payLoad)
    );
  },
  EmployeeGenerateSalary(payLoad) {
    return axios.post(
      apibaseurlHRMS + "EmployeeGenerateSalary",
      JSON.stringify(payLoad)
    );
  },
  //payslip
  GetEmployeePayslipMasterDetails(payLoad) {
    return axios.post(
      apibaseurlHRMS + "GetEmployeePayslipMasterDetails",
      JSON.stringify(payLoad)
    );
  },
  // format: "excel" | "pdf" -- generates the file server-side, uploads it to
  // S3 and returns a 1-hour presigned download URL (data.url/data.fileName).
  DownloadEmployeePayslipMasterDetails(payLoad) {
    return axios.post(
      apibaseurlHRMS + "DownloadEmployeePayslipMasterDetails",
      JSON.stringify(payLoad)
    );
  },
  GetEmployeeEarningDeductionDetails(payLoad) {
    return axios.post(
      apibaseurlHRMS + "GetEmployeeEarningDeductionDetails",
      JSON.stringify(payLoad)
    );
  },
  registration(user) {
    return axios.post(apibaseurlHRMS + "userregistration/add", user);
  },
  getCitiesByPin(pincode) {
    return axios.post(apibaseurlHRMS + "pincodes/get", pincode);
  },
  getAllBanks() {
    return axios.post(apibaseurlHRMS + "mstrbank/getall", {});
  },
  getMemberType() {
    return axios.post(apibaseurlHRMS + "mstrbank/getall", {});
  },
  getDashboardSummary(user) {
    return axios.post(apibaseurlHRMS + "dashboard", user);
  },
  getInvoices(user) {
    return axios.post(apibaseurlHRMS + "invoices/getByUserId", user);
  },
  getMemberList(user) {
    return axios.post(apibaseurlHRMS + "hierarchy/getMembers", user);
  },
  getHeirarchy(user) {
    return axios.post(apibaseurlHRMS + "hierarchy/get", user);
  },
  GetRoleList(data) {
    return axios.post(apibaseurlHRMS + "GetRoleList", JSON.stringify(data));
  },
  AddEditRole(data) {
    return axios.post(apibaseurlHRMS + "AddEditRole", JSON.stringify(data));
  },
  DeleteRole(data) {
    return axios.post(apibaseurlHRMS + "deleteRole", JSON.stringify(data));
  },

  GetMenuList(data) {
    return axios.post(apibaseurlHRMS + "GetMenuList", JSON.stringify(data));
  },
  AddMenu(data) {
    return axios.post(apibaseurlHRMS + "AddMenu", JSON.stringify(data));
  },
  EditMenu(data) {
    return axios.post(apibaseurlHRMS + "EditMenu", JSON.stringify(data));
  },
  GetMapMenuList(data) {
    return axios.post(apibaseurlHRMS + "GetMapMenuList", JSON.stringify(data));
  },
  MapMenu(data) {
    return axios.post(apibaseurlHRMS + "MapMenu", JSON.stringify(data));
  },
  DeleteMenu(data) {
    return axios.post(apibaseurlHRMS + "DeleteMenu", JSON.stringify(data));
  },
  reset_password(data) {
    return axios.post(apibaseurlHRMS + "reset_password", JSON.stringify(data));
  },
  // Live "Password Match" check on the change-password panel. Scoped
  // server-side to the caller's own employee_id, so it takes only the
  // plaintext - never an employee_id.
  verifyCurrentPassword(data) {
    return axios.post(apibaseurlHRMS + "verifyCurrentPassword", JSON.stringify(data));
  },
  addUserDetails(data) {
    return axios.post(apibaseurlHRMS + "addUserDetails", data);
  },
  getUsers(data) {
    return axios.post(apibaseurlHRMS + "getUsers", JSON.stringify(data));
  },
  unlockUser(data) {
    return axios.post(apibaseurlHRMS + "unlockUser", JSON.stringify(data));
  },
  deleteMasterUser(data) {
    return axios.post(apibaseurlHRMS + "deleteMasterUser", JSON.stringify(data));
  },
  getMasterUserById(data) {
    return axios.post(apibaseurlHRMS + "getMasterUserById", JSON.stringify(data));
  },
  // GetEmployeeAttendaceEachMonth(data) {
  //   return axios.post(apibaseurlHRMS + "GetEmployeeAttendaceEachMonth", JSON.stringify(data), {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: auth,
  //     },
  //   });
  // },
  GetEmployeeIncomeTaxMasterDetails(data) {
    return axios.post(
      apibaseurlHRMS + "GetEmployeeIncomeTaxMasterDetails",
      JSON.stringify(data)
    );
  },
  getAllRejectionReason(data) {
    return axios.post(
      apibaseurlHRMS + "getAllRejectionReason",
      JSON.stringify(data)
    );
  },
  getAllExpenseRejectionReason(data) {
    return axios.post(
      apibaseurlExpense + "getAllExpenseRejectionReason",
      JSON.stringify(data)
    );
  },
  GetReimbursementFinalizePaysheetList(data) {
    return axios.post(
      apibaseurlExpense + "GetReimbursementFinalizePaysheetList",
      JSON.stringify(data)
    );
  },
  getAllMasterLocationType(data) {
    return axios.post(
      apibaseurlHRMS + "getAllMasterLocationType",
      JSON.stringify(data)
    );
  },
  getReimbursementPaysheetDetail(data) {
    return axios.post(
      apibaseurlExpense + "getReimbursementPaysheetDetail",
      JSON.stringify(data)
    );
  },
  addReimbursementPaysheet(data) {
    return axios.post(
      apibaseurlExpense + "addReimbursementPaysheet",
      JSON.stringify(data)
    );
  },
  getAllEmployeeWithReimbursementDetail(data) {
    return axios.post(
      apibaseurlExpense + "getAllEmployeeWithReimbursementDetail",
      JSON.stringify(data)
    );
  },
  GetEmployeeIncomeTaxform24QDetails(data) {
    return axios.post(
      apibaseurlHRMS + "GetEmployeeIncomeTaxform24QDetails",
      JSON.stringify(data)
    );
  },
  getEmployeeCarryForwordLeaveDetail(data) {
    return axios.post(
      apibaseurlHRMS + "getEmployeeCarryForwordLeaveDetail",
      JSON.stringify(data)
    );
  },
  getEmployeeCarryForwordRemainingLeaveDetail(data) {
    return axios.post(
      apibaseurlHRMS + "getEmployeeCarryForwordRemainingLeaveDetail",
      JSON.stringify(data)
    );
  },
  addEmployeeLeaveCarryForwardDetails(data) {
    return axios.post(
      apibaseurlHRMS + "addEmployeeLeaveCarryForwardDetails",
      JSON.stringify(data)
    );
  },
  getAllQualification(data) {
    return axios.post(apibaseurlHRMS + "getAllQualification", JSON.stringify(data));
  },
  getAllMasterQualification(data) {
    return axios.post(
      apibaseurlHRMS + "getAllMasterQualification",
      JSON.stringify(data)
    );
  },
  deleteMasterQualification(data) {
    return axios.post(
      apibaseurlHRMS + "deleteMasterQualification",
      JSON.stringify(data)
    );
  },
  addMasterQualification(data) {
    return axios.post(
      apibaseurlHRMS + "addMasterQualification",
      JSON.stringify(data)
    );
  },
  getAllMasterPayrollDeductionItem(data) {
    return axios.post(
      apibaseurlHRMS + "getAllMasterPayrollDeductionItem",
      JSON.stringify(data)
    );
  },
  addMasterPayrollDeductionItem(data) {
    return axios.post(
      apibaseurlHRMS + "addMasterPayrollDeductionItem",
      JSON.stringify(data)
    );
  },
  deleteMasterPayrollDeductionItem(data) {
    return axios.post(
      apibaseurlHRMS + "deleteMasterPayrollDeductionItem",
      JSON.stringify(data)
    );
  },
  getAllMasterPayrollEarningItem(data) {
    return axios.post(
      apibaseurlHRMS + "getAllMasterPayrollEarningItem",
      JSON.stringify(data)
    );
  },
  addMasterPayrollEarningItem(data) {
    return axios.post(
      apibaseurlHRMS + "addMasterPayrollEarningItem",
      JSON.stringify(data)
    );
  },
  deleteMasterPayrollEarningItem(data) {
    return axios.post(
      apibaseurlHRMS + "deleteMasterPayrollEarningItem",
      JSON.stringify(data)
    );
  },
  getAllMasterProcessType(data) {
    return axios.post(
      apibaseurlHRMS + "getAllMasterProcessType",
      JSON.stringify(data)
    );
  },
  addMasterProcessType(data) {
    return axios.post(
      apibaseurlHRMS + "addMasterProcessType",
      JSON.stringify(data)
    );
  },
  deleteMasterProcessType(data) {
    return axios.post(
      apibaseurlHRMS + "deleteMasterProcessType",
      JSON.stringify(data)
    );
  },
  getAllMasterRejectionReason(data) {
    return axios.post(
      apibaseurlHRMS + "getAllMasterRejectionReason",
      JSON.stringify(data)
    );
  },
  addMasterRejectionReason(data) {
    return axios.post(
      apibaseurlHRMS + "addMasterRejectionReason",
      JSON.stringify(data)
    );
  },
  deleteMasterRejectionReason(data) {
    return axios.post(
      apibaseurlHRMS + "deleteMasterRejectionReason",
      JSON.stringify(data)
    );
  },
  getAllMasterReimbursementType(data) {
    return axios.post(
      apibaseurlHRMS + "getAllMasterReimbursementType",
      JSON.stringify(data)
    );
  },
  addMasterReimbursementType(data) {
    return axios.post(
      apibaseurlHRMS + "addMasterReimbursementType",
      JSON.stringify(data)
    );
  },
  deleteMasterReimbursementType(data) {
    return axios.post(
      apibaseurlHRMS + "deleteMasterReimbursementType",
      JSON.stringify(data)
    );
  },
  getAllMasterLocation(data) {
    return axios.post(
      apibaseurlHRMS + "getAllMasterLocation",
      JSON.stringify(data)
    );
  },
  addMasterLocation(data) {
    return axios.post(apibaseurlHRMS + "addMasterLocation", JSON.stringify(data));
  },
  deleteMasterLocation(data) {
    return axios.post(
      apibaseurlHRMS + "deleteMasterLocation",
      JSON.stringify(data)
    );
  },
  getAllMasterLocationType(data) {
    return axios.post(
      apibaseurlHRMS + "getAllMasterLocationType",
      JSON.stringify(data)
    );
  },
  getAllMasterExitReason(data) {
    return axios.post(
      apibaseurlHRMS + "getAllMasterExitReason",
      JSON.stringify(data)
    );
  },
  addMasterExitReason(data) {
    return axios.post(apibaseurlHRMS + "addMasterExitReason", JSON.stringify(data));
  },
  deleteMasterExitReason(data) {
    return axios.post(
      apibaseurlHRMS + "deleteMasterExitReason",
      JSON.stringify(data)
    );
  },
  // Employee No Prefix master (CTS, OS, CONTRACT, ATS, ...) - served by the Master API
  getEmployeeNoPrefixList(data) {
    return axios.post(apibaseurlMaster + "GetEmployeeNoPrefixList", JSON.stringify(data));
  },
  addEditEmployeeNoPrefix(data) {
    return axios.post(apibaseurlMaster + "AddEditEmployeeNoPrefix", JSON.stringify(data));
  },
  deleteEmployeeNoPrefix(data) {
    return axios.post(apibaseurlMaster + "DeleteEmployeeNoPrefix", JSON.stringify(data));
  },
  getAllMasterAttendanceRegularizeReason(data) {
    return axios.post(
      apibaseurlHRMS + "getAllMasterAttendanceRegularizeReason",
      JSON.stringify(data)
    );
  },
  addMasterAttendanceRegularizeReason(data) {
    return axios.post(
      apibaseurlHRMS + "addMasterAttendanceRegularizeReason",
      JSON.stringify(data)
    );
  },
  deleteMasterAttendanceRegularizeReason(data) {
    return axios.post(
      apibaseurlHRMS + "deleteMasterAttendanceRegularizeReason",
      JSON.stringify(data)
    );
  },
  getAllMasterTaxSlab(data) {
    return axios.post(apibaseurlHRMS + "getAllMasterTaxSlab", JSON.stringify(data));
  },
  addMasterTaxSlab(data) {
    return axios.post(apibaseurlHRMS + "addMasterTaxSlab", JSON.stringify(data));
  },
  deleteMasterTaxSlab(data) {
    return axios.post(apibaseurlHRMS + "deleteMasterTaxSlab", JSON.stringify(data));
  },
  getAllAttendanceRejectionReason(data) {
    return axios.post(
      apibaseurlHRMS + "getAllAttendanceRejectionReason",
      JSON.stringify(data)
    );
  },
  getAllMasterAnnualYearLeave(data) {
    return axios.post(
      apibaseurlHRMS + "getAllMasterAnnualYearLeave",
      JSON.stringify(data)
    );
  },
  addMasterAnnualYearLeave(data) {
    return axios.post(
      apibaseurlHRMS + "addMasterAnnualYearLeave",
      JSON.stringify(data)
    );
  },
  deleteMasterAnnualYearLeave(data) {
    return axios.post(
      apibaseurlHRMS + "deleteMasterAnnualYearLeave",
      JSON.stringify(data)
    );
  },
  GetEmployeeAttendanceRegularise(data) {
    return axios.post(
      apibaseurlHRMS + "GetEmployeeAttendanceRegularise",
      JSON.stringify(data)
    );
  },
  // format: "excel" | "pdf", month (1-12) and year required -- returns
  // { status, data: { url, fileName, totalRecords }, message }
  DownloadEmployeeAttendanceRegularise(data) {
    return axios.post(
      apibaseurlHRMS + "DownloadEmployeeAttendanceRegularise",
      JSON.stringify(data)
    );
  },
  // 1:1 face compare, direct to the third-party service: image1_url = employee's
  // S3 reference photo URL (plain string, no download needed), image2 = captured image file.
  // Superseded by verifyFaceForPunch (backend now compares against the
  // stored face embedding instead of the UI hitting the compare service directly).
  // compareFaceImages(formData) {
  //   return faceCompareAxios.post(faceCompareUrl, formData, {
  //     headers: {
  //       "Content-Type": "multipart/form-data",
  //     },
  //   });
  // },

  addTask(data) {
    return axios.post(apibaseurlProjectPlanning + "AddSFTask", JSON.stringify(data));
  },

  addBulkTask(data) {
    return axios.post(apibaseurlProjectPlanning + "AddBulkSFTask", JSON.stringify(data));
  },

  getTaskList(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFTaskList", JSON.stringify(data));
  },
  // getTaskById(data) {
  //   return axios.post(
  //     apibaseurlProjectPlanning + "GetSFTaskById",
  //     JSON.stringify(data),
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: "Bearer " + store.getters.authToken,
  //       },
  //     }
  //   );
  // },

  getTaskById(data) {
    return axios.post(
      apibaseurlProjectPlanning + "GetSFTaskById",
      {},
      {
        params: data,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + store.getters.authToken,
        },
      }
    );
  },

  editTask(data) {
    return axios.post(apibaseurlProjectPlanning + "UpdateSFTask", JSON.stringify(data));
  },
  getProjectList(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFProjectList", JSON.stringify(data));
  },
  addProject(data) {
    return axios.post(apibaseurlProjectPlanning + "AddSFProject", JSON.stringify(data));
  },
  updateProject(data) {
    return axios.post(apibaseurlProjectPlanning + "UpdateSFProject", JSON.stringify(data));
  },
  deleteProject(data) {
    return axios.post(apibaseurlProjectPlanning + "DeleteSFProject", JSON.stringify(data));
  },
  getProjectById(data) {
    return axios.post(
      apibaseurlProjectPlanning + "GetSFProjectById",
      {},
      {
        params: data,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + store.getters.authToken,
        },
      }
    );
  },

  deleteTask(data) {
    return axios.post(apibaseurlProjectPlanning + "DeleteSFTask", JSON.stringify(data));
  },
  // 🔹 SPRINT APIs
  getSprintList(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFSprintList", JSON.stringify(data));
  },
  addSprint(data) {
    return axios.post(apibaseurlProjectPlanning + "AddSFSprint", JSON.stringify(data));
  },
  getSprintById(data) {
    return axios.post(
      apibaseurlProjectPlanning + "GetSFSprintById",
      {},
      {
        params: {
          ...data,
          id: data.id || data.sprint_id,
          sprint_id: data.sprint_id || data.id,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + store.getters.authToken,
        },
      }
    );
  },
  updateSprint(data) {
    return axios.post(apibaseurlProjectPlanning + "UpdateSFSprint", JSON.stringify(data));
  },
  deleteSprint(data) {
    return axios.post(apibaseurlProjectPlanning + "DeleteSFSprint", JSON.stringify(data));
  },
  addBulkSprint(data) {
    return axios.post(apibaseurlProjectPlanning + "AddBulkSprint", JSON.stringify(data));
  },
  getTaskListBySprintId(data) {
    return axios.post(
      apibaseurlProjectPlanning + "GetTaskListBySprintId",
      JSON.stringify(data)
    );
  },
  addBulkSprintTasks(data) {
    return axios.post(apibaseurlProjectPlanning + "AddBulkSprintTasks", JSON.stringify(data));
  },
  updateBulkSprintTasks(data) {
    return axios.post(
      apibaseurlProjectPlanning + "UpdateBulkSprintTasks",
      JSON.stringify(data)
    );
  },
  deleteSprintTask(data) {
    return axios.post(apibaseurlProjectPlanning + "DeleteSprintTask", JSON.stringify(data));
  },
  updateSprintTask(data) {
    return axios.post(apibaseurlProjectPlanning + "UpdateSprintTask", JSON.stringify(data));
  },
  deletePaystructure(data) {
    return axios.post(apibaseurlHRMS + "deletePayStructure", JSON.stringify(data));
  },
  reindexEmployee(employeeId) {
    const url = `index-employee/${employeeId}`;
    console.log(" Calling reindex API for employee:", employeeId);
    console.log(" API URL:", apibaseurl2 + url);
  },
  //   return pythonAxios
  //     .post(url)
  //     .then((response) => {
  //       console.log(" Reindex API success:", response.data);
  //       return response;
  //     })
  //     .catch((error) => {
  //       console.error(" Reindex API error:", {
  //         status: error.response?.status,
  //         message: error.response?.data?.message || error.message,
  //         url: error.config?.url,
  //       });
  //       throw error;
  //     });
  // },
  // Triggers the backend to fetch the employee's photo, generate its face
  // embedding via the face API, and store it in face_embeddings.
  storeFaceEmbedding(data) {
    return axios.post(apibaseurlMaster + "storeFaceEmbedding", JSON.stringify(data));
  },
  // Gate checked before punch-in: does this employee have a stored face embedding?
  checkFaceEmbeddingExists(data) {
    return axios.post(apibaseurlMaster + "checkFaceEmbeddingExists", JSON.stringify(data));
  },
  // Punch-in/punch-out verification: compares the captured photo against the
  // employee's stored face embedding (not the stored photo).
  verifyFaceForPunch(data) {
    return axios.post(apibaseurlMaster + "verifyFaceForPunch", JSON.stringify(data));
  },
  getAuditLogs(data) {
    return axios.post(apibaseurlHRMS + "getAuditLogs", JSON.stringify(data));
  },
  getSFProjectAuditLog(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFProjectAuditLog", JSON.stringify(data));
  },

  //Expense-APIs
  // for Employees
  getAllReceipts(data) {
    return axios.post(apibaseurlExpense + "getAllReceipts", data || {});
  },
  // for admin, superadmin, manager, accountant
  // adminGetReceipt: loads a single receipt by id for the admin edit form.
  // Backed by /getReceiptById, which allows privileged-role access (unlike
  // /getReceipt, which is strictly owner-scoped).
  adminGetReceipt(data) {
    return axios.post(apibaseurlExpense + "getReceiptById", data);
  },
  // adminUserExpenseReport: used by the dashboards (pending-claim total) and
  // the reimbursement approval flow (receipts under a claim_id). Backed by
  // /getUserExpenseReport -- accepts {userId|employee_id} for "my pending
  // receipts", or {claimId} for "all receipts under this reimbursement claim".
  adminUserExpenseReport(data) {
    return axios.post(apibaseurlExpense + "getUserExpenseReport", data || {});
  },
  // for admins
  adminReceiptStats(data) {
    return axios.post(apibaseurlExpense + "getReceiptStats", data || {});
  },
  adminUpdateReceipt(data) {
    return axios.post(apibaseurlExpense + "adminEditReceipt", data);
  },
  adminDeleteReceipt(data) {
    return axios.post(apibaseurlExpense + "adminDeleteReceipt", data);
  },
  adminMonthlyExcelReport(data) {
    // Backend route is POST-only (serverless.yml); was previously issued as GET.
    return axios.post(apibaseurlExpense + "adminMonthlyExcelReport", data || {});
  },
  adminImportUpdateReceipt(data) {
    return axios.post(apibaseurlExpense + "adminImportUpdateReceipt", data);
  },
  adminImportUpdateReceiptClaimID(data) {
    return axios.post(apibaseurlExpense + "adminImportUpdateReceiptClaimID", data);
  },
  updatePaymentStatus(data) {
    return axios.post(apibaseurlExpense + "updatePaymentStatus", data);
  },
  // Returns the valid payment-status transitions ({status_id, status_name,
  // is_reject, rank}) for the requester's role, to drive the status
  // dropdown/filter instead of hardcoding status strings in the UI.
  getReceiptStatus(data) {
    return axios.post(apibaseurlExpense + "getReceiptStatus", data || {});
  },
  //users monthly pdf and excel report
  userMonthlyPDFReport(data) {
    return axios.post(apibaseurlExpense + "userMonthlyPDFReport", data);
  },
  userMonthlyExcelReport(data) {
    return axios.post(apibaseurlExpense + "userMonthlyExcelReport", data);
  },
  // Export of the current filtered expense list (as opposed to the monthly
  // admin/user report above). format: "excel" | "pdf" -- returns
  // { status, data: { url, fileName, totalRecords }, message }
  DownloadEmployeeExpense(data) {
    return axios.post(apibaseurlExpense + "DownloadEmployeeExpense", data);
  },

  // for employees
  getReceiptById(data) {
    return axios.post(apibaseurlExpense + "getReceiptById", data);
  },
  // for employees
  getReceiptStats() {
    return axios.post(apibaseurlExpense + "getReceiptStats", {});
  },
  // createReceipt: submits a new expense receipt (OCR-scanned or manual entry).
  createReceipt(data) {
    return axios.post(apibaseurlExpense + "addExpenseReceipt", JSON.stringify(data));
  },
  updateReceipt(data) {
    return axios.post(apibaseurlExpense + "updateReceipt", data);
  },
  deleteReceipt(data) {
    // Assuming deleteReceipt expects the ID in the body or params, we pass data
    return axios.post(apibaseurlExpense + "deleteReceipt", data);
  },
  analyzeReceipt(formData) {
    return axios.post("http://65.0.55.53:3000/analyze", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  addExpenseReceipt(data) {
    return axios.post(apibaseurlExpense + "addExpenseReceipt", JSON.stringify(data));
  },
  getSFProjects(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFProjectList", JSON.stringify(data));
  },
  getSFProjectById(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFProjectById", JSON.stringify(data));
  },
  addSFProject(data) {
    return axios.post(apibaseurlProjectPlanning + "AddSFProject", JSON.stringify(data));
  },
  updateSFProject(data) {
    return axios.post(apibaseurlProjectPlanning + "UpdateSFProject", JSON.stringify(data));
  },
  deleteSFProject(data) {
    return axios.post(apibaseurlProjectPlanning + "DeleteSFProject", JSON.stringify(data));
  },

  // ─── SF BACKLOG ─────────────────────────────────────────
  getSFBacklogByProject(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFBacklogList", JSON.stringify(data));
  },
  getSFBacklogItemById(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFBacklogItemById", JSON.stringify(data));
  },
  addSFBacklogItem(data) {
    return axios.post(apibaseurlProjectPlanning + "AddSFBacklogItem", JSON.stringify(data));
  },
  updateSFBacklogItem(data) {
    return axios.post(apibaseurlProjectPlanning + "UpdateSFBacklogItem", JSON.stringify(data));
  },
  /**
   * Bulk update backlog items to assign them to a sprint
   * @param {Object} data - Payload with sprint_id and array of backlog_item_ids
   * @param {number} data.sprint_id - Target sprint ID
   * @param {Array} data.backlog_item_ids - Array of backlog item IDs to assign
   * @returns {Promise} API response
   */
  updateSFBacklogItemSprint(data) {
    return axios.post(apibaseurlProjectPlanning + "UpdateSFBacklogItem", JSON.stringify(data));
  },
  deleteSFBacklogItem(data) {
    return axios.post(apibaseurlProjectPlanning + "DeleteSFBacklogItem", JSON.stringify(data));
  },

  // ─── SF SPRINTS ─────────────────────────────────────────
  /**
   * Get list of SF (Project) Sprints for dropdown/selection
   * @param {Object} data - Filter payload (project_id, is_active, etc.)
   * @returns {Promise} API response with sprint list
   */
  getSFSprints(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFSprintList", JSON.stringify(data));
  },
  getSFSprintsByProject(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFSprintList", JSON.stringify(data));
  },
  getSFSprintById(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFSprintById", JSON.stringify(data));
  },
  addSFSprint(data) {
    return axios.post(apibaseurlProjectPlanning + "AddSFSprint", JSON.stringify(data));
  },
  updateSFSprint(data) {
    return axios.post(apibaseurlProjectPlanning + "UpdateSFSprint", JSON.stringify(data));
  },
  completeSFSprint(data) {
    return axios.post(apibaseurlProjectPlanning + "CompleteSFSprint", JSON.stringify(data));
  },
  deleteSFSprint(data) {
    return axios.post(apibaseurlProjectPlanning + "DeleteSFSprint", JSON.stringify(data));
  },

  // ─── SF BOARD (reuses UpdateSFBacklogItem for status moves) ─
  getSFSprintBoard(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFBacklogList", JSON.stringify(data));
  },
  // moveSFTask(data) {
  //   return axios.post(apibaseurlProjectPlanning + "UpdateSFBacklogItem", JSON.stringify(data));
  // },

  // ─── DSM SESSIONS ────────────────────────────────────────
  getDSMSessions(data) {
    return axios.post(apibaseurlProjectPlanning + "GetDSMSessions", JSON.stringify(data));
  },
  getDSMSessionById(data) {
    return axios.post(apibaseurlProjectPlanning + "GetDSMSessionById", JSON.stringify(data));
  },
  addDSMSession(data) {
    return axios.post(apibaseurlProjectPlanning + "AddDSMSession", JSON.stringify(data));
  },
  updateDSMSession(data) {
    return axios.post(apibaseurlProjectPlanning + "UpdateDSMSession", JSON.stringify(data));
  },
  deleteDSMSession(data) {
    return axios.post(apibaseurlProjectPlanning + "DeleteDSMSession", JSON.stringify(data));
  },
  toggleDSMSessionStatus(data) {
    return axios.post(apibaseurlProjectPlanning + "ToggleDSMSessionStatus", JSON.stringify(data));
  },

  // ─── DSM ENTRIES ─────────────────────────────────────────
  getDSMEntries(data) {
    return axios.post(apibaseurlProjectPlanning + "GetDSMEntries", JSON.stringify(data));
  },
  getMyDSMEntry(data) {
    return axios.post(apibaseurlProjectPlanning + "GetMyDSMEntry", JSON.stringify(data));
  },
  addDSMEntry(data) {
    return axios.post(apibaseurlProjectPlanning + "AddDSMEntry", JSON.stringify(data));
  },
  updateDSMEntry(data) {
    return axios.post(apibaseurlProjectPlanning + "UpdateDSMEntry", JSON.stringify(data));
  },
  deleteDSMEntry(data) {
    return axios.post(apibaseurlProjectPlanning + "DeleteDSMEntry", JSON.stringify(data));
  },
  getMySprintTasks(data) {
    return axios.post(apibaseurlProjectPlanning + "GetMySprintTasks", JSON.stringify(data));
  },

  // ─── REPORTS ─────────────────────────────────────────────
  getSFBurndownData(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFBurndownData", JSON.stringify(data));
  },
  addSFBurndownLog(data) {
    return axios.post(apibaseurlProjectPlanning + "AddSFBurndownLog", JSON.stringify(data));
  },
  getSFVelocityData(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFVelocityReport", JSON.stringify(data));
  },
  getSFTeamWorkload(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFWorkloadReport", JSON.stringify(data));
  },
  getSFMemberWorkload(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFWorkloadReport", JSON.stringify(data));
  },
  //─── SFTASK ─────────────────────────────────────────────
  /**
   * Add a single SF (Project) Task
   * @param {Object} data - Task data object
   * @returns {Promise} API response promise
   */
  addSFTask(data) {
    return axios.post(apibaseurlProjectPlanning + "AddSFTask", JSON.stringify(data));
  },
  /**
   * Add multiple SF (Project) Tasks in bulk
   * @param {Object} data - Object containing sprint_id and tasks array
   * @param {number} data.sprint_id - The sprint ID
   * @param {Array} data.tasks - Array of task objects with properties like task_title, developer_code, tester_code, etc.
   * @returns {Promise} API response promise containing results of bulk insert operation
   */
  addBulkSFTask(data) {
    return axios.post(apibaseurlProjectPlanning + "AddBulkSFTask", JSON.stringify(data));
  },
  updateSFTask(data) {
    return axios.post(apibaseurlProjectPlanning + "UpdateSFTask", JSON.stringify(data));
  },
  updateTaskStatus(data) {
    return axios.post(apibaseurlProjectPlanning + "UpdateTaskStatus", JSON.stringify(data));
  },
  // Canonical task statuses, each with allowed_next (the statuses it may move to).
  getSFTaskStatusList(data = {}) {
    return axios.post(apibaseurlProjectPlanning + "GetSFTaskStatusList", JSON.stringify(data));
  },
  // Narrow update used by the Sprint Board timer (actual dev/test hours only) —
  // deliberately does NOT touch task_title, developers/testers, effort estimates, remarks, etc.
  // No "start" timestamp is ever persisted — each session starts counting from now.
  updateTaskTimer(data) {
    return axios.post(apibaseurlProjectPlanning + "UpdateTaskTimer", JSON.stringify(data));
  },
  // Explicit pause/resume for the board's timer button. Both are server-clock
  // authoritative — the response's actual_dev_hours/actual_test_hours/
  // timer_started_at are the source of truth, not anything computed locally.
  pauseTaskTimer(data) {
    return axios.post(apibaseurlProjectPlanning + "PauseTaskTimer", JSON.stringify(data));
  },
  resumeTaskTimer(data) {
    return axios.post(apibaseurlProjectPlanning + "ResumeTaskTimer", JSON.stringify(data));
  },
  deleteSFTask(data) {
    return axios.post(apibaseurlProjectPlanning + "DeleteSFTask", JSON.stringify(data));
  },
  getSFTaskById(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFTaskById", JSON.stringify(data));
  },
  GetSFTaskList(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFTaskList", JSON.stringify(data));
  },
  completeSFTask(data) {
    return axios.post(apibaseurlProjectPlanning + "completeSFTask", JSON.stringify(data));
  },
  // Card History: task header (project/sprint/created-by) + the audit-logged
  // timeline (created, status moves, assignment adds/removes). Merge with
  // GetSFTaskCommentList's comments on the frontend for the full activity feed.
  getSFTaskHistory(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFTaskHistory", JSON.stringify(data));
  },
  GetSFTaskCommentList(data) {
    return axios.post(apibaseurlProjectPlanning + "GetSFTaskCommentList", JSON.stringify(data));
  },
  addSFTaskComment(data) {
    return axios.post(apibaseurlProjectPlanning + "AddSFTaskComment", JSON.stringify(data));
  },
  updateSFTaskComment(data) {
    return axios.post(apibaseurlProjectPlanning + "UpdateSFTaskComment", JSON.stringify(data));
  },
  deleteSFTaskComment(data) {
    return axios.post(apibaseurlProjectPlanning + "DeleteSFTaskComment", JSON.stringify(data));
  },

  // ---- MRF (Manpower Requisition Form) ----
  getAllMasterJobDescription(data) {
    return axios.post(apibaseurlStaffing + "getAllMasterJobDescriptionNew", JSON.stringify(data));
  },
  addMasterJobDescription(data) {
    return axios.post(apibaseurlStaffing + "addMasterJobDescriptionNew", JSON.stringify(data));
  },
  updateMasterJobDescription(data) {
    return axios.post(apibaseurlStaffing + "updateMasterJobDescriptionNew", JSON.stringify(data));
  },
  deleteMasterJobDescription(data) {
    return axios.post(apibaseurlStaffing + "deleteMasterJobDescriptionNew", JSON.stringify(data));
  },
  getAllMasterEmploymentType(data) {
    return axios.post(apibaseurlStaffing + "getAllMasterEmploymentTypeNew", JSON.stringify(data || {}));
  },
  getAllMasterManpowerType(data) {
    return axios.post(apibaseurlStaffing + "getAllMasterManpowerType", JSON.stringify(data || {}));
  },
  getAllMasterGrade(data) {
    return axios.post(apibaseurlStaffing + "getAllMasterGrade", JSON.stringify(data || {}));
  },
  addEditMRF(data) {
    return axios.post(apibaseurlStaffing + "AddEditMRF", JSON.stringify(data));
  },
  getMRFList(data) {
    return axios.post(apibaseurlStaffing + "GetMRFList", JSON.stringify(data));
  },
  getMRFById(data) {
    return axios.post(apibaseurlStaffing + "GetMRFById", JSON.stringify(data));
  },
  submitMRFForApproval(data) {
    return axios.post(apibaseurlStaffing + "SubmitMRFForApproval", JSON.stringify(data));
  },
  getMRFStatusOptions(data) {
    return axios.post(apibaseurlStaffing + "GetMRFStatusOptions", JSON.stringify(data));
  },
  actionMRFApproval(data) {
    return axios.post(apibaseurlStaffing + "ActionMRFApproval", JSON.stringify(data));
  },
  getMRFApprovalHistory(data) {
    return axios.post(apibaseurlStaffing + "GetMRFApprovalHistory", JSON.stringify(data));
  },
  getMRFJoinedCandidates(data) {
    return axios.post(apibaseurlStaffing + "GetMRFJoinedCandidates", JSON.stringify(data));
  },
  getAllMRFRejectionReason(data) {
    return axios.post(apibaseurlStaffing + "GetAllMRFRejectionReason", JSON.stringify(data));
  },
  deleteMRF(data) {
    return axios.post(apibaseurlStaffing + "DeleteMRF", JSON.stringify(data));
  },

  // ---- Recruitment Tracker + Personnel-File (RTM) — gated to 'Under Review' ----
  getRecruitmentTracker(data) {
    return axios.post(apibaseurlStaffing + "GetRecruitmentTracker", JSON.stringify(data));
  },
  getRecruitmentPipelineStatusOptions(data) {
    return axios.post(apibaseurlStaffing + "GetRecruitmentPipelineStatusOptions", JSON.stringify(data || {}));
  },
  addEditRecruitmentTracker(data) {
    //asws
    return axios.post(apibaseurlStaffing + "AddEditRecruitmentTracker", JSON.stringify(data));
  },
  addBulkRecruitmentTracker(data) {
    return axios.post(apibaseurlStaffing + "AddBulkRecruitmentTracker", JSON.stringify(data));
  },
  deleteRecruitmentTracker(data) {
    return axios.post(apibaseurlStaffing + "DeleteRecruitmentTracker", JSON.stringify(data));
  },
  removeJoinedCandidate(data) {
    return axios.post(apibaseurlStaffing + "RemoveJoinedCandidate", JSON.stringify(data));
  },
  addRecruitmentFollowup(data) {
    return axios.post(apibaseurlStaffing + "AddRecruitmentFollowup", JSON.stringify(data));
  },
  getFollowups(data) {
    return axios.post(apibaseurlStaffing + "GetFollowups", JSON.stringify(data));
  },
  getRecruitmentStatusHistory(data) {
    return axios.post(apibaseurlStaffing + "GetRecruitmentStatusHistory", JSON.stringify(data));
  },
  getPersonnelTrace(data) {
    return axios.post(apibaseurlStaffing + "GetPersonnelTrace", JSON.stringify(data));
  },
  addEditPersonnelTrace(data) {
    return axios.post(apibaseurlStaffing + "AddEditPersonnelTrace", JSON.stringify(data));
  },

  // ---- Offer Letter — gated on offer_acceptance_date being set ----
  getOfferLetterDetail(data) {
    return axios.post(apibaseurlStaffing + "GetOfferLetterDetail", JSON.stringify(data));
  },
  addEditOfferLetterDetail(data) {
    return axios.post(apibaseurlStaffing + "AddEditOfferLetterDetail", JSON.stringify(data));
  },
  generateOfferLetterPdf(data) {
    return axios.post(apibaseurlStaffing + "GenerateOfferLetterPdf", JSON.stringify(data));
  },
  getOfferLetterPdfUrl(data) {
    return axios.post(apibaseurlStaffing + "GetOfferLetterPdfUrl", JSON.stringify(data));
  },

  // ---- Candidate Documents (Declaration + NDA) ----
  getCandidateDocuments(data) {
    return axios.post(apibaseurlStaffing + "GetCandidateDocuments", JSON.stringify(data));
  },
  generateDocumentPdf(data) {
    return axios.post(apibaseurlStaffing + "GenerateDocumentPdf", JSON.stringify(data));
  },
  getDocumentPdfUrl(data) {
    return axios.post(apibaseurlStaffing + "GetDocumentPdfUrl", JSON.stringify(data));
  },
  markDocumentAcknowledged(data) {
    return axios.post(apibaseurlStaffing + "MarkDocumentAcknowledged", JSON.stringify(data));
  },

  // ---- Candidate Onboarding — gated on final_outcome_status = 'Acceptance' ----
  onboardCandidate(data) {
    return axios.post(apibaseurlStaffing + "OnboardCandidate", JSON.stringify(data));
  },

  // ---- Employee Exit (Exit Request / Exit Interview) ----
  createExitRequest(data) {
    return axios.post(apibaseurlMaster + "CreateEmpExitRequest", JSON.stringify(data));
  },
  getExitRequestByEmployee(data) {
    return axios.post(apibaseurlMaster + "GetEmpExitRequestByEmployee", JSON.stringify(data));
  },
  getExitRequestList(data) {
    return axios.post(apibaseurlMaster + "GetEmpExitRequestList", JSON.stringify(data));
  },
  getExitRequestDetails(data) {
    return axios.post(apibaseurlMaster + "GetEmpExitRequestDetails", JSON.stringify(data));
  },
  getExitInterviewStatusOptions(data) {
    return axios.post(apibaseurlMaster + "GetEmpExitInterviewStatusOptions", JSON.stringify(data));
  },
  submitExitInterview(data) {
    return axios.post(apibaseurlMaster + "SubmitEmpExitInterview", JSON.stringify(data));
  },

  // ---- Employee Exit Workflow (dedicated schema: New -> Discuss -> Forward
  // to HR -> Exit Interview -> Approved, plus Cancel). Separate from the
  // Exit Request/Exit Interview APIs above. ----
  createExitWorkflowRequest(data) {
    return axios.post(apibaseurlMaster + "CreateExitWorkflowRequest", JSON.stringify(data));
  },
  getExitWorkflowReasonList() {
    return axios.post(apibaseurlMaster + "GetExitWorkflowReasonList", JSON.stringify({}));
  },
  previewExitNoticePeriod(data) {
    return axios.post(apibaseurlMaster + "PreviewExitNoticePeriod", JSON.stringify(data));
  },
  getMyExitWorkflowRequest(data = {}) {
    return axios.post(apibaseurlMaster + "GetMyExitWorkflowRequest", JSON.stringify(data));
  },
  getExitWorkflowList(data) {
    return axios.post(apibaseurlMaster + "GetExitWorkflowList", JSON.stringify(data));
  },
  getExitWorkflowDetail(data) {
    return axios.post(apibaseurlMaster + "GetExitWorkflowDetail", JSON.stringify(data));
  },
  submitExitWorkflowAction(data) {
    return axios.post(apibaseurlMaster + "SubmitExitWorkflowAction", JSON.stringify(data));
  },

  // ===== TRAINING =====
  getTrnPing(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnPing", JSON.stringify(data));
  },
  getTrnMyPermissions(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnMyPermissions", JSON.stringify(data));
  },
  // Competencies
  getTrnCompetencyList(data) {
    return axios.post(apibaseurlTraining + "GetTrnCompetencyList", JSON.stringify(data));
  },
  getTrnCompetencyById(data) {
    return axios.post(apibaseurlTraining + "GetTrnCompetencyById", JSON.stringify(data));
  },
  addTrnCompetency(data) {
    return axios.post(apibaseurlTraining + "AddTrnCompetency", JSON.stringify(data));
  },
  updateTrnCompetency(data) {
    return axios.post(apibaseurlTraining + "UpdateTrnCompetency", JSON.stringify(data));
  },
  deleteTrnCompetency(data) {
    return axios.post(apibaseurlTraining + "DeleteTrnCompetency", JSON.stringify(data));
  },
  // Trainers
  getTrnTrainerList(data) {
    return axios.post(apibaseurlTraining + "GetTrnTrainerList", JSON.stringify(data));
  },
  getTrnTrainerById(data) {
    return axios.post(apibaseurlTraining + "GetTrnTrainerById", JSON.stringify(data));
  },
  addTrnTrainer(data) {
    return axios.post(apibaseurlTraining + "AddTrnTrainer", JSON.stringify(data));
  },
  updateTrnTrainer(data) {
    return axios.post(apibaseurlTraining + "UpdateTrnTrainer", JSON.stringify(data));
  },
  deleteTrnTrainer(data) {
    return axios.post(apibaseurlTraining + "DeleteTrnTrainer", JSON.stringify(data));
  },
  // Courses
  getTrnCourseList(data) {
    return axios.post(apibaseurlTraining + "GetTrnCourseList", JSON.stringify(data));
  },
  getTrnCourseById(data) {
    return axios.post(apibaseurlTraining + "GetTrnCourseById", JSON.stringify(data));
  },
  addTrnCourse(data) {
    return axios.post(apibaseurlTraining + "AddTrnCourse", JSON.stringify(data));
  },
  updateTrnCourse(data) {
    return axios.post(apibaseurlTraining + "UpdateTrnCourse", JSON.stringify(data));
  },
  deleteTrnCourse(data) {
    return axios.post(apibaseurlTraining + "DeleteTrnCourse", JSON.stringify(data));
  },
  saveTrnCourseCompetencies(data) {
    return axios.post(apibaseurlTraining + "SaveTrnCourseCompetencies", JSON.stringify(data));
  },
  saveTrnCourseTrainers(data) {
    return axios.post(apibaseurlTraining + "SaveTrnCourseTrainers", JSON.stringify(data));
  },
  // Course materials. Upload = getTrnMaterialUploadUrl -> PUT the file to the
  // returned upload_url -> addTrnCourseMaterial with the returned file_key.
  getTrnCourseMaterials(data) {
    return axios.post(apibaseurlTraining + "GetTrnCourseMaterials", JSON.stringify(data));
  },
  getTrnMaterialUploadUrl(data) {
    return axios.post(apibaseurlTraining + "GetTrnMaterialUploadUrl", JSON.stringify(data));
  },
  addTrnCourseMaterial(data) {
    return axios.post(apibaseurlTraining + "AddTrnCourseMaterial", JSON.stringify(data));
  },
  getTrnMaterialUrl(data) {
    return axios.post(apibaseurlTraining + "GetTrnMaterialUrl", JSON.stringify(data));
  },
  deleteTrnCourseMaterial(data) {
    return axios.post(apibaseurlTraining + "DeleteTrnCourseMaterial", JSON.stringify(data));
  },
  // Competency matrix (designation x competency) and mandatory courses
  getTrnRoleMatrix(data) {
    return axios.post(apibaseurlTraining + "GetTrnRoleMatrix", JSON.stringify(data));
  },
  saveTrnRoleMatrix(data) {
    return axios.post(apibaseurlTraining + "SaveTrnRoleMatrix", JSON.stringify(data));
  },
  getTrnRoleMandatoryCourses(data) {
    return axios.post(apibaseurlTraining + "GetTrnRoleMandatoryCourses", JSON.stringify(data));
  },
  saveTrnRoleMandatoryCourses(data) {
    return axios.post(apibaseurlTraining + "SaveTrnRoleMandatoryCourses", JSON.stringify(data));
  },
  runTrnRequirementCheck(data) {
    return axios.post(apibaseurlTraining + "RunTrnRequirementCheck", JSON.stringify(data));
  },
  // Employee competency profile
  getTrnEmployeeLookup(data) {
    return axios.post(apibaseurlTraining + "GetTrnEmployeeLookup", JSON.stringify(data));
  },
  getTrnEmployeeCompetency(data) {
    return axios.post(apibaseurlTraining + "GetTrnEmployeeCompetency", JSON.stringify(data));
  },
  saveTrnEmployeeCompetency(data) {
    return axios.post(apibaseurlTraining + "SaveTrnEmployeeCompetency", JSON.stringify(data));
  },
  // Training Needs Analysis
  getTrnTnaList(data) {
    return axios.post(apibaseurlTraining + "GetTrnTnaList", JSON.stringify(data));
  },
  getTrnTnaById(data) {
    return axios.post(apibaseurlTraining + "GetTrnTnaById", JSON.stringify(data));
  },
  getTrnTnaNeeds(data) {
    return axios.post(apibaseurlTraining + "GetTrnTnaNeeds", JSON.stringify(data));
  },
  createTrnTna(data) {
    return axios.post(apibaseurlTraining + "CreateTrnTna", JSON.stringify(data));
  },
  generateTrnTnaGaps(data) {
    return axios.post(apibaseurlTraining + "GenerateTrnTnaGaps", JSON.stringify(data));
  },
  submitTrnTna(data) {
    return axios.post(apibaseurlTraining + "SubmitTrnTna", JSON.stringify(data));
  },
  approveTrnTna(data) {
    return axios.post(apibaseurlTraining + "ApproveTrnTna", JSON.stringify(data));
  },
  rejectTrnTna(data) {
    return axios.post(apibaseurlTraining + "RejectTrnTna", JSON.stringify(data));
  },
  reviseTrnTna(data) {
    return axios.post(apibaseurlTraining + "ReviseTrnTna", JSON.stringify(data));
  },
  addTrnTnaNeed(data) {
    return axios.post(apibaseurlTraining + "AddTrnTnaNeed", JSON.stringify(data));
  },
  updateTrnTnaNeed(data) {
    return axios.post(apibaseurlTraining + "UpdateTrnTnaNeed", JSON.stringify(data));
  },
  deleteTrnTnaNeed(data) {
    return axios.post(apibaseurlTraining + "DeleteTrnTnaNeed", JSON.stringify(data));
  },
  // Training Plan
  getTrnPlanList(data) {
    return axios.post(apibaseurlTraining + "GetTrnPlanList", JSON.stringify(data));
  },
  getTrnPlanById(data) {
    return axios.post(apibaseurlTraining + "GetTrnPlanById", JSON.stringify(data));
  },
  getTrnPlanVersionDiff(data) {
    return axios.post(apibaseurlTraining + "GetTrnPlanVersionDiff", JSON.stringify(data));
  },
  createTrnPlan(data) {
    return axios.post(apibaseurlTraining + "CreateTrnPlan", JSON.stringify(data));
  },
  submitTrnPlan(data) {
    return axios.post(apibaseurlTraining + "SubmitTrnPlan", JSON.stringify(data));
  },
  approveTrnPlan(data) {
    return axios.post(apibaseurlTraining + "ApproveTrnPlan", JSON.stringify(data));
  },
  rejectTrnPlan(data) {
    return axios.post(apibaseurlTraining + "RejectTrnPlan", JSON.stringify(data));
  },
  reviseTrnPlan(data) {
    return axios.post(apibaseurlTraining + "ReviseTrnPlan", JSON.stringify(data));
  },
  addTrnPlanItem(data) {
    return axios.post(apibaseurlTraining + "AddTrnPlanItem", JSON.stringify(data));
  },
  updateTrnPlanItem(data) {
    return axios.post(apibaseurlTraining + "UpdateTrnPlanItem", JSON.stringify(data));
  },
  deleteTrnPlanItem(data) {
    return axios.post(apibaseurlTraining + "DeleteTrnPlanItem", JSON.stringify(data));
  },
  // Sessions & nominations
  getTrnSessionList(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnSessionList", JSON.stringify(data));
  },
  getTrnSessionById(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnSessionById", JSON.stringify(data));
  },
  createTrnSession(data = {}) {
    return axios.post(apibaseurlTraining + "CreateTrnSession", JSON.stringify(data));
  },
  updateTrnSession(data = {}) {
    return axios.post(apibaseurlTraining + "UpdateTrnSession", JSON.stringify(data));
  },
  cancelTrnSession(data = {}) {
    return axios.post(apibaseurlTraining + "CancelTrnSession", JSON.stringify(data));
  },
  nominateTrnEmployees(data = {}) {
    return axios.post(apibaseurlTraining + "NominateTrnEmployees", JSON.stringify(data));
  },
  autoNominateTrnSession(data = {}) {
    return axios.post(apibaseurlTraining + "AutoNominateTrnSession", JSON.stringify(data));
  },
  getTrnPendingNominations(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnPendingNominations", JSON.stringify(data));
  },
  decideTrnNominations(data = {}) {
    return axios.post(apibaseurlTraining + "DecideTrnNominations", JSON.stringify(data));
  },
  withdrawTrnNomination(data = {}) {
    return axios.post(apibaseurlTraining + "WithdrawTrnNomination", JSON.stringify(data));
  },
  // Attendance, assessment, completion, certificates
  getTrnSessionRoster(data) {
    return axios.post(apibaseurlTraining + "GetTrnSessionRoster", JSON.stringify(data));
  },
  markTrnAttendance(data) {
    return axios.post(apibaseurlTraining + "MarkTrnAttendance", JSON.stringify(data));
  },
  saveTrnAssessmentScores(data) {
    return axios.post(apibaseurlTraining + "SaveTrnAssessmentScores", JSON.stringify(data));
  },
  completeTrnSession(data) {
    return axios.post(apibaseurlTraining + "CompleteTrnSession", JSON.stringify(data));
  },
  getTrnCertificateUrl(data) {
    return axios.post(apibaseurlTraining + "GetTrnCertificateUrl", JSON.stringify(data));
  },
  // Effectiveness: L1 feedback, L3 evaluation
  getTrnPendingFeedback(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnPendingFeedback", JSON.stringify(data));
  },
  submitTrnFeedbackL1(data = {}) {
    return axios.post(apibaseurlTraining + "SubmitTrnFeedbackL1", JSON.stringify(data));
  },
  getTrnSessionFeedback(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnSessionFeedback", JSON.stringify(data));
  },
  getTrnPendingL3(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnPendingL3", JSON.stringify(data));
  },
  submitTrnEvaluationL3(data = {}) {
    return axios.post(apibaseurlTraining + "SubmitTrnEvaluationL3", JSON.stringify(data));
  },
  // Waivers (FR-07). Evidence upload = getTrnWaiverUploadUrl -> PUT the file to
  // the returned upload_url -> requestTrnWaiver with the returned file_key.
  getTrnWaiverUploadUrl(data) {
    return axios.post(apibaseurlTraining + "GetTrnWaiverUploadUrl", JSON.stringify(data));
  },
  requestTrnWaiver(data) {
    return axios.post(apibaseurlTraining + "RequestTrnWaiver", JSON.stringify(data));
  },
  getTrnWaiverList(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnWaiverList", JSON.stringify(data));
  },
  getTrnPendingWaivers(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnPendingWaivers", JSON.stringify(data));
  },
  decideTrnWaiver(data) {
    return axios.post(apibaseurlTraining + "DecideTrnWaiver", JSON.stringify(data));
  },
  cancelTrnWaiver(data) {
    return axios.post(apibaseurlTraining + "CancelTrnWaiver", JSON.stringify(data));
  },
  getTrnWaiverEvidenceUrl(data) {
    return axios.post(apibaseurlTraining + "GetTrnWaiverEvidenceUrl", JSON.stringify(data));
  },
  // Hubs (FR-09): my training, transcript ({ employee_id } or {} for mine), team overview.
  getTrnMyTraining(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnMyTraining", JSON.stringify(data));
  },
  getTrnTranscript(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnTranscript", JSON.stringify(data));
  },
  getTrnTeamOverview(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnTeamOverview", JSON.stringify(data));
  },
  // Dashboards (FR-09, trn_report): filters { department_id, designation_id, location_id },
  // period { from, to } "YYYY-MM-DD" (empty = this year to date).
  getTrnComplianceSummary(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnComplianceSummary", JSON.stringify(data));
  },
  getTrnOverdueMandatory(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnOverdueMandatory", JSON.stringify(data));
  },
  getTrnPlannedVsActual(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnPlannedVsActual", JSON.stringify(data));
  },
  getTrnEffectivenessTrend(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnEffectivenessTrend", JSON.stringify(data));
  },
  getTrnHoursPerEmployee(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnHoursPerEmployee", JSON.stringify(data));
  },
  // Evidence pack (FR-10): the cover + section catalog, then each section page by page.
  getTrnEvidencePack(data = {}) {
    return axios.post(apibaseurlTraining + "GetTrnEvidencePack", JSON.stringify(data));
  },
  getTrnEvidenceSection(data) {
    return axios.post(apibaseurlTraining + "GetTrnEvidenceSection", JSON.stringify(data));
  },
};
// deleteTask(data) {
//   return axios.post(apibaseurlProjectPlanning + "DeleteSFTask", data, { // ✅ no stringify
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: "Bearer " + store.getters.authToken, // sir boleche remove kora jabe na 👍
//     },
//   });
// },
// };
